import * as React from 'react';

import {Button} from 'shells/button/button';
import {SyncRegularIcon} from 'shells/icon/svg/sync-regular-icon';

import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {TransferEditionContentModal} from './transfer-edition-content-modal';

type Props = {
    edition: Edition;
};

export function TransferEditionContentButton(props: Props) {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

    return (
        <>
            <Button
                variant='text-secondary'
                size='big'
                icon={SyncRegularIcon}
                onClick={() => setIsModalOpen(true)}
            >
                Transfer content between versions
            </Button>
            {isModalOpen && props.edition && (
                <TransferEditionContentModal
                    edition={props.edition}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </>
    );
}
